function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88,11.39,12,2.53a.82.82,0,0,0-1.08,0L1.12,11.39a.81.81,0,0,0,.54,1.41H3.8v7.06a.81.81,0,0,0,.81.81H9.53a.81.81,0,0,0,.81-.81V14.77h2.32v5.09a.81.81,0,0,0,.81.81h4.92a.81.81,0,0,0,.81-.81V12.8h2.14a.81.81,0,0,0,.54-1.41Z",
    style: {
      fill: "#5e4394"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeActive);
export default __webpack_public_path__ + "static/media/ic-home-active.28559642917e12d2aa6550aef420fa1e.svg";
export { ForwardRef as ReactComponent };